import { Layout, Avatar, Dropdown, Space, Typography, message } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { GET_MEMBER } from "../../services/apiEndPoints";
import axios from "../../services/axiosInstance";
import { useEffect } from "react";

const { Header } = Layout;
const { Text } = Typography;

const AppHeader = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    message.success("Logged out successfully");
    navigate("/login");
  };

  const getUserDetails = async () => {
    const user = await axios.get(GET_MEMBER, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
  };

  const items = [
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: handleLogout,
    },
  ];

  useEffect(() => {
    getUserDetails();
  }, []);

  return (
    <Header
      style={{
        position: "fixed",
        top: 0,
        zIndex: 1000,
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
      }}
    >
      {/* Left: Logo + Title */}
      <Space
        align="center"
        style={{ cursor: "pointer", marginTop: 15 }}
        onClick={() => navigate("/")}
      >
        <img
          src="../../logo.png"
          alt="Admin Logo"
          style={{
            height: 32,
            width: 32,
            objectFit: "contain",
            marginTop: 15,
            marginRight: 8,
          }}
        />
        <Text strong style={{ fontSize: 16, color: "white" }}>
          Admin
        </Text>
      </Space>

      {/* Right: User menu */}
      <Dropdown menu={{ items }} trigger={["click"]}>
        <Space style={{ cursor: "pointer" }}>
          <Avatar icon={<UserOutlined />} />
          <Text style={{ color: "white" }}>User</Text>
        </Space>
      </Dropdown>
    </Header>
  );
};

export default AppHeader;
